<ion-grid class="safe-area-top">
  <ion-row>
    <ion-col>
      <div (click)="activateNullContainer()" class="arrow-back" title="Back">
        <ion-icon name="chevron-back"></ion-icon>
      </div>
      <span *ngIf="title === 'Club Chat'">
        <app-notifications-toggle></app-notifications-toggle>
      </span>
    </ion-col>
    <ion-col class="flex-center">
      <ion-label>{{ title }}</ion-label></ion-col>
      <ion-col class="flex-d">
        <img
          src="/assets/img/certified-flair.png"
        />
      </ion-col>
  </ion-row>
</ion-grid>
